import { useTranslation } from 'react-i18next';
import { archiveGeneralCondition } from './utils/archiveGeneralCondition';
import { useAuthContext } from '../../../contexts/AuthContext';
import { useErrorMessage } from '../../../utils/errorMessage';
import {
  createDateColumns,
  createArchiveActionsColumn
} from '../utils/columnsUtils';

export const useColumns = ({
  setPurpose,
  setGeneralConditionToEdit,
  setVisible
}) => {
  const { t } = useTranslation();
  const { dispatchAPI } = useAuthContext();
  const { message } = useErrorMessage();

  return [
    ...createDateColumns(t, 'general-conditions.form'),
    createArchiveActionsColumn({
      setPurpose,
      setRecordToEdit: setGeneralConditionToEdit,
      setVisible,
      onArchive: archiveGeneralCondition,
      t,
      dispatchAPI,
      message
    })
  ];
};
